import {enableProdMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';

import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import {rewriteLegacyLocation} from './app/cabinet/shared/routing/rewrite-legacy-location';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Слой A паритета SSR/CSR (SEO-8 §6.10): перезапись legacy-URL ДО старта роутера.
//
// Именно до `bootstrapApplication`, а не guard'ом: роутер стартует уже на новом URL,
// поэтому применяются гарды НОВОГО роута (иначе аноним по публичной legacy-ссылке
// улетал бы на /sign-in), нет двойной навигации и мигания 404, а крошки, canonical и
// SeoMetaService с самого начала видят финальный URL.
//
// На SSR-деплое это no-op: мидлварь уже отдала 301, а `toNewPath` идемпотентна.
// `typeof window` — единственный корректный способ отличить браузер здесь: DI ещё нет.
if (typeof window !== 'undefined') {
  rewriteLegacyLocation(window.location, window.history);
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
